import epfm from './epfm/index.vue';

const components = [epfm];

const install = function(Vue) {
    components.forEach(comp => {
        Vue.component(comp.name,comp)
    })
};

export default install;